<template>
	<div class="qualification-body">
		<!-- <div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">店铺名称：{{shopName}}</span> -->
				<!-- <el-input
					v-model=""
					class="name-input"
					disabled
					size="mini"
				></el-input> -->
			<!-- </div>
		</div> -->
		<div class="qualification-container">
			<CurrentCom :editDisable="editDisable"/>
		</div>
	</div>
</template>

<script>
import CurrentCom from '@/components/storeSetting/qualification/CurrentCom.vue'
export default {
	name: 'qualification',
	components: {
		CurrentCom
	},
	data () {
		return {
			tabActive: '0',
			shopName: '',
			qualificationShow: false,
			componentShow: true,
			editDisable: true
		}
	},
	created () {
		this.shopName = window.sessionStorage.getItem('shopName')
		this.getAuthority('01_0001_0000_00')
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					if (a.indexOf('01_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('isAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.qualification-body {
	display: flex
	flex: 1
	height: 100%
	flex-direction column
	min-height: 0
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.qualification-container {
		display: flex;
		flex: 1;
		overflow-y: auto;
		flex-direction: column;
		.qualification-header {
			padding: 10px 0
			text-align left
			position relative
		}
	}
}
</style>
